import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mainFilter'
})
export class MainFilterPipe implements PipeTransform {

  transform(items: any[], filter: any): any {
    if (!items || !filter) {
      return items;
    }
    
    // Filter to Lower Case
    const filterLc = filter.toLowerCase();

    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    
    return items.filter(item => {
      const test = item.title.rendered.toLowerCase();
      const test2 =  item.content.rendered.toLowerCase();
      return test.includes(filterLc) || test2.includes(filterLc);
    });  
  
  }

}



// WEBPACK FOOTER //
// C:/Users/gdb/Documents/work/garrido-angular/garrido-front/src/app/main-filter.pipe.ts